import React, { ReactElement } from 'react';
import { Card, Modal, ModalProps } from 'react-bootstrap';
import { CancelButton, SubmitButton } from '../buttons';
import { Title } from './title';

type FlexibleModalProps = {
  show: boolean;
  title: string;
  confirmButtonMessage?: string;
  secondaryConfirmButtonMessage?: string;
  cancelButtonMessage?: string;
  onConfirm?: (...args: any[]) => any;
  onSecondaryConfirm?: (...args: any[]) => any;
  onCancel?: (...args: any[]) => any;
  confirmButtonVariant?: string;
  disabledSubmit?: boolean;
  disabledSecondarySubmit?: boolean;
  disabledCancel?: boolean;
  size?: ModalProps['size'];
  children?: ReactElement<any>;
  bodyClassName?: string;
};

export const FlexibleModal: React.FC<React.PropsWithChildren<FlexibleModalProps>> = ({
  show,
  title,
  confirmButtonMessage,
  secondaryConfirmButtonMessage,
  cancelButtonMessage,
  onConfirm = () => {},
  onSecondaryConfirm = () => {},
  onCancel = () => {},
  confirmButtonVariant,
  disabledSubmit,
  disabledSecondarySubmit,
  disabledCancel,
  size,
  children,
  bodyClassName,
}) => {
  return (
    <Modal animation={false} show={show} onHide={onCancel} centered size={size}>
      <Card className="with-dark-shadow">
        <Title title={title} />
        <Card.Body {...(bodyClassName ? { className: bodyClassName } : {})}>
          <div className="modal-wrap">{children}</div>
        </Card.Body>{' '}
        {(confirmButtonMessage || cancelButtonMessage) && (
          <div className="card-footer-actions">
            {confirmButtonMessage && (
              <SubmitButton isDirty={true} disabled={disabledSubmit} onClick={onConfirm} variant={confirmButtonVariant}>
                {confirmButtonMessage}
              </SubmitButton>
            )}

            {secondaryConfirmButtonMessage && (
              <SubmitButton isDirty={true} disabled={disabledSecondarySubmit} onClick={onSecondaryConfirm} variant={'danger'}>
                {secondaryConfirmButtonMessage}
              </SubmitButton>
            )}

            {cancelButtonMessage && (
              <CancelButton isDirty={true} disabled={disabledCancel} onClick={onCancel}>
                {cancelButtonMessage}
              </CancelButton>
            )}
          </div>
        )}
      </Card>
    </Modal>
  );
};
